import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/app/hellojob-pro/src/home/client.tsx");
